import React from 'react';
import { useParams } from 'react-router';
import { DashboardLayout } from '../components/DashboardLayout';
import i18n from '@/utils/i18n';
import ClassicLoadingSpinner from '../../../../components/LoadingSpinner/ClassicLoadingSpinner';
import { useGetEventAccountQuery } from '../../../../graphql/queries/getEventAccount.generated';
import OrderFulfillmentsTableWithFilter from '../../components/OrderFulfillmentsTableWithFilter';

type FulfillmentsPageProps = {};

export const EventAccountFulfillmentsPage = (props: FulfillmentsPageProps) => {
  const { eventAccountId, eventId } = useParams<{
    eventAccountId: string;
    eventId: string;
  }>();

  const { data, loading } = useGetEventAccountQuery({
    variables: { id: eventAccountId },
    errorPolicy: 'all',
  });

  if (loading) {
    return (
      <DashboardLayout title={i18n.t('EventsDashboard:fulfillments')}>
        {<ClassicLoadingSpinner />}
      </DashboardLayout>
    );
  }

  if (data?.eventAccount != null) {
    return (
      <DashboardLayout title={i18n.t('EventsDashboard:fulfillments')}>
        <h3>{i18n.t('EventsDashboard:fulfillments')}</h3>
        <OrderFulfillmentsTableWithFilter
          authorizedSigners={data.eventAccount.authorized_signers.map((a) => ({
            id: a.id,
            name: a.name,
          }))}
          events={
            data.eventAccount.participating_in_events
              ?.filter((e) => e.id === eventId)
              ?.map((e) => ({ id: e.id, name: e.name ?? '' })) ?? []
          }
          itemLocations={
            data.eventAccount.item_locations?.map((l) => ({
              id: l.id,
              name: l.name,
            })) ?? []
          }
          eventAccounts={[
            {
              id: data.eventAccount.id,
              name: data.eventAccount.name ?? '',
            },
          ]}
          filter={{
            event_account_id: eventAccountId,
            event_id: eventId,
          }}
        />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout title={i18n.t('EventsDashboard:fulfillments')}>
      {i18n.t('Common:error')}
    </DashboardLayout>
  );
};
